export const SBC_MODES = {
    LIST: 'List',
    ADD: 'Add',
    EDIT: 'Edit',
};

export const initialState = {
    priority: '',
    name: '',
    locationID: null,
    isActive: true,
};

export const addHeader = 'SBC Details';
export const editHeader = 'Edit SBC Details';

export const ERROR_MESSAGES = {
    NAME_INVALID:
        'Field is required and can only contain alphanumeric characters and hyphens.',
    LOCATION_REQUIRED: 'Field is required.',
};
